import styled from "styled-components";

export const StyledUserSection = styled.section`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
`

export const StyledAdminPage = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: black;
    width: 70%;
    margin: 0 auto;
    
    @media (max-width: 768px) {
        width: 100%;
  }
`

